import React, { useState, useEffect } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import ListGroup from 'react-bootstrap/ListGroup';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import Alert from 'react-bootstrap/Alert';
import NoData from '../components/NoData.js';
import moment from 'moment';
import AppointmentModal from '../components/appointment/AppointmentModal';
import AppointmentAllModal from '../components/appointment/AppointmentAllModal';
import PolicyModal from '../components/appointment/PolicyModal';
import { SingleDatePicker, isInclusivelyBeforeDay, isInclusivelyAfterDay } from 'react-dates';
import { FormattedMessage, useIntl } from 'react-intl';
import { AlertSwal } from '../components/CustomSwal';
import '../components/css/appointment.css';

function Appointment(props) {
  const [startDate, setStartDate] = useState(null);
  const [startDate_focus, setStartDate_focus] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [endDate_focus, setEndDate_focus] = useState(null);
  const [data, setData] = useState(null);
  const [remainData, setRemainData] = useState(null);
  const [zoneData, setZoneData] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);
  const [currentEventKey, setCurrentEventKey] = useState(null);
  const [params, setParams] = useState(null);
  const [show, setShow] = useState(false);
  const [allShow, setAllShow] = useState(false);
  const [policyShow, setPolicyShow] = useState(false);
  const [allData, setAllData] = useState(null);

  const sid = sessionStorage.getItem('sid');
  const authid = sessionStorage.getItem('authid');
  const isblacklist = sessionStorage.getItem('isblacklist');
  const cardnoexist = sessionStorage.getItem('cardnoexist');
  const config = props.config;
  const formType = currentEventKey ? config.SPACETYPE[`st_${currentEventKey}`][0] : null;
  const intl = useIntl();

  const GetCanBookSpaceType = () => {
    props.setLoading(true);
    axios.get(config.API_URL + `/GetCanBookSpaceType.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          if (data.resdata) {
            let stateData = [];
            for (let i = 0; i < config.ST_ORDER.length; i++) {
              let spacetype_index = config.ST_ORDER[i].toString();
              data.resdata.map((row, index) => {
                if (row.spacetype === spacetype_index) {
                  stateData.push(row);
                }
                return null;
              })
            }
            setData(stateData);
          } else {
            setData([]);
          }
          GetRemainderSpace();
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    })
  }

  const GetRemainderSpace = () => {
    axios.get(config.API_URL + `/GetRemainderSpace.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          if (data.resdata) {
            setRemainData(data.resdata);
          } else {
            setRemainData([]);
          }
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  const GetZoneInfo = (elem) => {
    const spacetype = elem.target.getAttribute('spacetype');
    setCurrentEventKey(spacetype);
    setStartDate(moment());
    if (spacetype !== currentEventKey) {
      props.setLoading(true);
      axios.get(config.API_URL + `/GetZoneInfo.aspx`, {
        params: {
          sid: sid,
          authid: authid,
          spacetype: spacetype,
          restype: 'json'
        }
      }).then((res) => {
        const data = res.data[0];
        if (data.rescode === '3' || data.rescode === '4') {
          props.setSession(false);
        } else {
          if (data.rescode === '1') {
            setZoneData(data.resdata);
            GetParams(spacetype);
          } else {
            AlertSwal.fire({
              title: intl.formatMessage({ id: 'global.alert_title' }),
              text: data.resmsg,
              confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
            })
          }
        }
      }).catch((error) => {
        console.error(error)
      })
    } else {
      setParams(null);
      setStartDate(null);
      setEndDate(null);
      setCurrentEventKey(null);
      setZoneData(null);
    }
  }

  const GetParams = (spacetype) => {
    axios.get(config.API_URL + `/GetParams.aspx`, {
      params: {
        sid: sid,
        authid: authid,
        spacetype: spacetype,
        restype: 'json'
      }
    }).then((res) => {
      const data = res.data[0];
      if (data.rescode === '3' || data.rescode === '4') {
        props.setSession(false);
      } else {
        if (data.rescode === '1') {
          setParams(data.resdata[0]);
          let bookrealeasedays = parseInt(data.resdata[0].bookrealeasedays);
          if (bookrealeasedays === 0) {
            bookrealeasedays = 1;
          }
          let edate = moment().add((parseInt(data.resdata[0].oncecanbooktime) - 1), 'days');
          let lastdate = moment().add(bookrealeasedays - 1, 'days');
          if (edate.isAfter(lastdate, 'days')) {
            edate = lastdate;
          }
          setEndDate(edate);
        } else {
          AlertSwal.fire({
            title: intl.formatMessage({ id: 'global.alert_title' }),
            text: data.resmsg,
            confirmButtonText: intl.formatMessage({ id: 'global.confirm' })
          })
        }
      }
    }).catch((error) => {
      console.error(error)
    }).finally(() => {
      props.setLoading(false);
    })
  }

  const selectZone = (elem) => {
    const zoneid = elem.target.getAttribute('zoneid');
    const zonename = elem.target.getAttribute('zonename');
    setSelectedZone({
      zoneid: zoneid,
      zonename: zonename,
      spacetype: currentEventKey,
      params: params
    });
    if (document.documentElement.clientWidth > config.POLICY_SHOW_WIDTH) {
      setPolicyShow(true);
    } else {
      setShow(true);
    }
  }

  const SchAllModal = () => {
    let zonename = '';
    data.find(elem => {
      if (elem.spacetype === currentEventKey) {
        zonename = elem.spacetypename;
      }
      return null;
    });
    const params = {
      enableToBook: false,
      spacetype: currentEventKey,
      sdate: startDate.format('YYYY/MM/DD'),
      edate: formType === 'date' ? endDate.format('YYYY/MM/DD') : null,
      zonename: zonename
    }
    setAllData(params);
    setAllShow(true);
  }

  useEffect(GetCanBookSpaceType, []);


  const setScrollCount = props.setScrollCount;
  useEffect(() => {
    return function clearModalCount() {
      setScrollCount(0);
    }
  }, [setScrollCount]);

  if (data === null) {
    return '';
  } else if (data.length === 0) {
    return <NoData />;
  }

  let showEndDate = formType === 'date' ?
    <>
      <b style={{ margin: '0 3px' }}>~</b>
      <SingleDatePicker
        id="endDate"
        date={endDate}
        focused={endDate_focus}
        onDateChange={(e) => {
          setEndDate(e);
        }}
        onFocusChange={(e) => {
          setEndDate_focus(e.focused);
        }}
        placeholder=''
        displayFormat="YYYY/MM/DD"
        numberOfMonths={1}
        block
        readOnly
        disabled
      />
    </>
    : null;

  return (
    <>
      {cardnoexist === '0' ?
        <Alert variant='danger' className='mb-2 mt-1 font-weight-bold'>※ <FormattedMessage id='appointment.cardnoexist_message' /></Alert>
        : isblacklist === '1' ?
          <Alert variant='danger' className='mb-2 mt-1 font-weight-bold'>※ <FormattedMessage id='appointment.isblacklist_message' /></Alert>
          : null}
      <Accordion>
        {
          data.map((row, index) => {
            return (
              <Card className={`card_spacetype_${row.spacetype}`} key={row.spacetype} style={{ border: 'none' }}>
                <Accordion.Toggle className={`room_spacetype_${row.spacetype} room_btn w-100 pt-3 pb-3 mt-1 mb-1` + (currentEventKey === row.spacetype ? ` active` : ``)} eventKey={row.spacetype} onClick={GetZoneInfo} spacetype={row.spacetype}>
                  <FormattedMessage defaultMessage={row.spacetypename} id={`global.spacetype.${row.spacetype}`} />
                </Accordion.Toggle>
                <Accordion.Collapse eventKey={row.spacetype}>
                  <ListGroup variant="flush" className='pl-1 pr-1 border'>
                    {props.messages.appointment.spacetype_info[row.spacetype] ?
                      <ListGroup.Item className='p-2'>
                        <Alert variant='danger' className='mb-0'>{props.messages.appointment.spacetype_info[row.spacetype]}</Alert>
                      </ListGroup.Item>
                      : null}
                    {(config.SHOW_CHECK_ALL_SPACE && (currentEventKey === row.spacetype)) ?
                      <ListGroup.Item className='p-2'>
                        <InputGroup className={"mb-1 startdate flex-nowrap align-items-" + (formType === 'date' ? 'center' : 'stretch')}>
                          <SingleDatePicker
                            id="startDate"
                            date={startDate}
                            focused={startDate_focus}
                            onDateChange={(e) => {
                              setStartDate(e);
                              let bookrealeasedays = parseInt(params.bookrealeasedays);
                              if (bookrealeasedays === 0) {
                                bookrealeasedays = 1;
                              }
                              let edate = moment(e).add((parseInt(params.oncecanbooktime) - 1), 'days');
                              let lastdate = moment().add(bookrealeasedays - 1, 'days');
                              if (edate.isAfter(lastdate, 'days')) {
                                edate = lastdate;
                              }
                              setEndDate(edate);
                            }}
                            onFocusChange={(e) => {
                              setStartDate_focus(e.focused);
                            }}
                            isOutsideRange={(day) => {
                              if (params === null) {
                                return null;
                              } else {
                                let bookrealeasedays = parseInt(params.bookrealeasedays);
                                if (bookrealeasedays === 0) {
                                  bookrealeasedays = 1;
                                }
                                return !isInclusivelyBeforeDay(day, moment().add(bookrealeasedays - 1, "days")) ||
                                  !isInclusivelyAfterDay(day, moment());
                              }
                            }}
                            // placeholder={intl.formatMessage({ id: 'appointment.choose_spacetype_first' })}
                            displayFormat="YYYY/MM/DD"
                            numberOfMonths={(document.documentElement.clientWidth < 576 ? 1 : 2)}
                            withPortal
                            block
                            readOnly
                          />
                          {showEndDate}
                          {formType === 'date' ? null :
                            <InputGroup.Append>
                              <Button title={intl.formatMessage({ id: 'appointment.choose_spacetype_first' })} variant="primary" disabled={currentEventKey ? false : true} onClick={SchAllModal}>
                                <FormattedMessage id='appointment.check_current_button' />
                              </Button>
                            </InputGroup.Append>
                          }
                        </InputGroup>
                        {formType === 'date' ?
                          <div className="d-flex justify-content-end">
                            <Button title={intl.formatMessage({ id: 'appointment.choose_spacetype_first' })} variant="primary" disabled={currentEventKey ? false : true} onClick={SchAllModal}>
                              <FormattedMessage id='appointment.check_current_button' />
                            </Button>
                          </div>
                          : null}
                      </ListGroup.Item>
                      : null}
                    {zoneData === null ? <Col sm={12}>Loading</Col> :
                      zoneData.length === 0 ? <Col sm={12}>No Data Found</Col> :
                        zoneData.map((row, index) => {
                          let count = null;
                          remainData.find(elem => {
                            if (elem.zonename === row.zonename) {
                              count = elem.count;
                            }
                            return null;
                          });
                          return (
                            <ListGroup.Item key={index}>
                              <div className="d-flex justify-content-between align-items-center">
                                <b className="d-grid">
                                  <FormattedMessage defaultMessage={row.zonename} id={`global.zoneid.${row.zoneid}`} />
                                  {
                                    config.SHOW_CURRENT_SPACE ?
                                      <span className="d-inline-block text-primary">
                                        <FormattedMessage id='appointment.now_available' values={{ count: count }} />
                                      </span>
                                      :
                                      null
                                  }
                                </b>
                                {cardnoexist === '1' && isblacklist === '0' ?
                                  <Button variant="success" zoneid={row.zoneid} zonename={row.zonename} onClick={selectZone}><FormattedMessage id='appointment.add_reservation' /></Button>
                                  : null}
                              </div>
                            </ListGroup.Item>
                          )
                        })
                    }
                  </ListGroup>
                </Accordion.Collapse>
              </Card>
            )
          })
        }
      </Accordion>
      {show ?
        <AppointmentModal
          {...props}
          show={show}
          setshow={setShow}
          selectedzone={selectedZone}
          setSession={props.setSession}
          setSelectedZone={setSelectedZone}
          setAllShow={setAllShow}
          setAllData={setAllData}
          SchAllModal={SchAllModal}
          params={params}
        />
        : null}
      {allShow ?
        <AppointmentAllModal
          {...props}
          show={allShow}
          allData={allData}
          selectedzone={selectedZone}
          setAllShow={setAllShow}
          setshow={setShow}
          params={params}
        />
        : null}
      {policyShow ?
        <PolicyModal
          {...props}
          show={policyShow}
          selectedzone={selectedZone}
          setSelectedZone={setSelectedZone}
          setPolicyShow={setPolicyShow}
          setshow={setShow}
          params={params}
        />
        : null}
      <div className="d-none">
        <form id='googleForm' action={props.config.GOOGLE_AUTH_URL} method='post' target='_blank'>
          <input type='hidden' name='spacetype' />
          <input type='hidden' name='deviceid' />
          <input type='hidden' name='readerid' />
          <input type='hidden' name='booksdate' />
          <input type='hidden' name='bookedate' />
          <input type='hidden' name='binbooktime' />
        </form>
      </div>
    </>
  )
}

export default Appointment;